<template src="../templates/normal_fcont_146.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import PrintButton from '../components/PrintButton'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    PrintButton,InfoMachineTranslation,AppDownloadCreative,
    AppDownloadPhotoPlus
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  methods: {
    clickGiftsCategory: function () {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "category_link",
        "custom_parameter2": "gifts"
      })

      this.$router.push({ 
        path: '/' + this.$store.state.lg2 + '/categories/gifts',
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
      })
    }
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['146-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['146-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
.category_item {
  margin-top: 25px;
  margin-bottom: 15px;
  padding: 10px 10px;
  border-radius: 4px;
  width: 100%;
  max-width: 300px;
  border: 1px solid #ddd;
  background-color: white;
}

.category_item_img {
  width: 120px;
  height: auto;
  margin: 0 auto;
  border-radius: 50%;
}

.category_item_img img {
  padding: 0px;
  border-radius: 50%;
  transition: 0.2s;
  width: 120px;
}

.category_item_text {
  padding: 0px;
  height: 100%;
}

.category_item_title {
  font-size: 16px;
  color: black;
  padding: 0;
  margin: 0;
  margin-top: 10px;
  text-align: center;
  border-radius: 4px 0 0 4px;
}

/* hover */
button.category_item:hover .category_item_title {
  text-decoration: underline;
}
button.category_item:hover .category_item_img img {
  opacity: 0.5;
}

/* background-color */
.category_item_gifts .category_item_img {
  background-color: rgba(201, 160, 58, 1);
}

@media screen and (max-width: 767px) {
  .category_item {
    width: 150px;
  }
}
</style>

